import { render } from "./add-tax.vue?vue&type=template&id=bc2b7cc2"
import script from "./add-tax.vue?vue&type=script&lang=js"
export * from "./add-tax.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__